export default __webpack_public_path__ + "static/media/event-action-sms.a640344f.svg";